import { GestureDetector } from "@-/com.npmjs.react-native-gesture-handler";
import type { ReactElement } from "react";

import type { useLearnCardButtonPress } from "#use-learn-card-button-press";

/** Observes touches on `children` (a button) for `useLearnCardButtonPress`. */
export function LearnFlashcardButtonPressDetector({
  children,
  press,
}: {
  children: ReactElement;
  press: ReturnType<typeof useLearnCardButtonPress>;
}) {
  return <GestureDetector gesture={press.gesture}>{children}</GestureDetector>;
}
